export default "__VITE_ASSET__615de93e__"